var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6051 22.1653V9.83496C28.6051 9.65752 28.5574 9.48328 28.4671 9.33012C28.3767 9.17695 28.2469 9.05038 28.0908 8.96339L16.9944 2.77589C16.8434 2.69169 16.673 2.64746 16.4998 2.64746C16.3266 2.64746 16.1562 2.69169 16.0052 2.77589L4.90874 8.96339C4.75273 9.05038 4.62289 9.17695 4.53252 9.33012C4.44216 9.48328 4.39453 9.65752 4.39453 9.83496V22.1653C4.39453 22.3427 4.44216 22.5169 4.53252 22.6701C4.62289 22.8233 4.75273 22.9499 4.90874 23.0368L16.0052 29.2243C16.1562 29.3085 16.3266 29.3528 16.4998 29.3528C16.673 29.3528 16.8434 29.3085 16.9944 29.2243L28.0908 23.0368C28.2469 22.9499 28.3767 22.8233 28.4671 22.6701C28.5574 22.5169 28.6051 22.3427 28.6051 22.1653Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4649 9.32827L16.6184 16L4.5332 9.32715",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6203 16L16.502 29.3527",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAsset);
export default __webpack_public_path__ + "static/media/icon-asset.ecadfb7b275ae9e9c3831f2cc68b832f.svg";
export { ForwardRef as ReactComponent };